import { connect } from "react-redux";
import DetailPdc from "../../../pages/basepdc/detailPdc/Detail.basepdc";
const mapStateToProps = (state, ownProps) => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps, null)(DetailPdc);



// WEBPACK FOOTER //
// src/containers/metier/pdc/detail.pdc.container.js